"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$prima, _theme$customTypograp, _theme$customTypograp2, _theme$customTypograp3, _theme$customTypograp4, _theme$customTypograp5, _theme$customTypograp6, _theme$customTypograp7, _theme$customTypograp8, _theme$customTypograp9, _theme$customTypograp10, _theme$customTypograp11, _theme$customTypograp12;

  return {
    icon: {
      marginRight: theme === null || theme === void 0 ? void 0 : theme.spacing(2)
    },
    link: {
      alignItems: "center",
      color: "inherit",
      display: "inline-flex",
      "&:hover, &:focus": {
        color: theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main
      }
    },
    linkSelected: {
      color: theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$prima = _theme$palette2.primary) === null || _theme$palette2$prima === void 0 ? void 0 : _theme$palette2$prima.main
    },
    linkLevel1: _objectSpread({}, theme === null || theme === void 0 ? void 0 : (_theme$customTypograp = theme.customTypography) === null || _theme$customTypograp === void 0 ? void 0 : (_theme$customTypograp2 = _theme$customTypograp.menu01) === null || _theme$customTypograp2 === void 0 ? void 0 : (_theme$customTypograp3 = _theme$customTypograp2.mainmenu) === null || _theme$customTypograp3 === void 0 ? void 0 : (_theme$customTypograp4 = _theme$customTypograp3.mobile) === null || _theme$customTypograp4 === void 0 ? void 0 : _theme$customTypograp4.level1),
    linkLevel2: _objectSpread({}, theme === null || theme === void 0 ? void 0 : (_theme$customTypograp5 = theme.customTypography) === null || _theme$customTypograp5 === void 0 ? void 0 : (_theme$customTypograp6 = _theme$customTypograp5.menu01) === null || _theme$customTypograp6 === void 0 ? void 0 : (_theme$customTypograp7 = _theme$customTypograp6.mainmenu) === null || _theme$customTypograp7 === void 0 ? void 0 : (_theme$customTypograp8 = _theme$customTypograp7.mobile) === null || _theme$customTypograp8 === void 0 ? void 0 : _theme$customTypograp8.level2),
    linkLevel3: _objectSpread({}, theme === null || theme === void 0 ? void 0 : (_theme$customTypograp9 = theme.customTypography) === null || _theme$customTypograp9 === void 0 ? void 0 : (_theme$customTypograp10 = _theme$customTypograp9.menu01) === null || _theme$customTypograp10 === void 0 ? void 0 : (_theme$customTypograp11 = _theme$customTypograp10.mainmenu) === null || _theme$customTypograp11 === void 0 ? void 0 : (_theme$customTypograp12 = _theme$customTypograp11.mobile) === null || _theme$customTypograp12 === void 0 ? void 0 : _theme$customTypograp12.level3),
    iconRight: {
      marginLeft: theme === null || theme === void 0 ? void 0 : theme.spacing(0.5)
    },
    iconBottom: {
      marginLeft: theme === null || theme === void 0 ? void 0 : theme.spacing(0.5)
    }
  };
});

var MobileMenuItem = function MobileMenuItem(_ref) {
  var _clsx;

  var click = _ref.click,
      hasChildren = _ref.hasChildren,
      icon = _ref.icon,
      iconBottom = _ref.iconBottom,
      iconRight = _ref.iconRight,
      level = _ref.level,
      link = _ref.link,
      selected = _ref.selected,
      target = _ref.target,
      title = _ref.title;
  var css = useStyles();
  var hasHref = link && !hasChildren ? true : false;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("menu-01-mobile-menuitem", "menu-01-mobile-menuitem__level" + level)
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx2.default)("menu-01-mobile-menuitem__link", css.link, (_clsx = {}, _defineProperty(_clsx, css.linkSelected, selected), _defineProperty(_clsx, "menu-01-mobile-menuitem__link--selected", selected), _defineProperty(_clsx, css.linkLevel1, level === 1), _defineProperty(_clsx, css.linkLevel2, level === 2), _defineProperty(_clsx, css.linkLevel3, level === 3), _clsx)),
    href: hasHref ? link : "#",
    target: target ? target : null,
    onClick: function onClick(e) {
      if (hasHref) return;
      e.preventDefault();
      click();
    }
  }, icon && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: ((0, _clsx2.default)("menu-01-mobile-menuitem__icon"), css.icon),
    src: icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx2.default)("menu-01-mobile-menuitem__title", css.title),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), hasChildren && iconRight && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: (0, _clsx2.default)("menu-01-mobile-menuitem__icon-right", css.iconRight),
    src: iconRight
  }), hasChildren && iconBottom && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: iconBottom,
    className: (0, _clsx2.default)("menu-01-mobile-menuitem__icon-bottom", css.iconBottom)
  })));
};

MobileMenuItem.propTypes = {
  click: _propTypes.default.func,
  hasChildren: _propTypes.default.bool,
  icon: _propTypes.default.string,
  iconBottom: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  level: _propTypes.default.number,
  link: _propTypes.default.string.isRequired,
  selected: _propTypes.default.bool,
  target: _propTypes.default.string,
  title: _propTypes.default.string.isRequired
};
var _default = MobileMenuItem;
exports.default = _default;